import React, { useEffect, useState } from 'react';
// import SummaryCards from './summaryCards';
// import RevenueChart from './revenueChart';
// import TicketSales from './ticketSales';
// import EventList from './eventList';
import styles from './dashboard.module.scss';
import { Country } from 'country-state-city';
import _get from 'lodash/get';
import _find from 'lodash/find';
import { KoCharts,KoSkeleton, KoText, KoTitle } from 'packages';
import KoIcon from '@kwapio/icons';
import LollipopLabelChart from './lollipopLabelChart';
import EventsByTypeChart from './eventsByTypeChart';
// import TicketStepLineChart from './ticketStepLineChart';
import { ClientsAPI } from '../customers.service';
import { ATYPE, CUSTOMER_MANAGEMNT_WORKFLOW } from '../customersList/constant';
import RoundedBarLineChartConfig from './revenue';
import ChannelByTypeChart from './channelpie';
import RatingByTypeChart from './ratingChars';
import RatingChartConfig from './ratingEngg';
export default function Dashboard() {
  const [, setWorkflows] = useState([]);
  const [, setAccountType] = useState([]);
  const [workflowCount, setWorkflowCount] = useState([]);
  const [typeCount, setTypeCount] = useState([]);
  const [RatingsData, setRatingsData] = useState([]);
  const [engagementData, setEngagementData] = useState([]);
  const [customerGrowth, setCustomerGrowth] = useState([]);
  const [locationsData, setLocationsData] = useState([]);
  const [countriesList] = useState(Country.getAllCountries());
  const [selectedCountry, setSelectedCountry] = useState('');
  const [dashboardCards, setDashboardCards] = useState([
    {
      label: 'Total Customer',
      icon: 'TaskClockCompltionFilled',
      arrow: 'ArrowLineUpFilled',
      description: '8% last month',
      value: `0`
    },
    {
      label: 'Total Active',
      icon: 'RevenueFilled',
      value: `0`,
      description: 'Total created project tasks',
      arrow: 'ArrowLineUpFilled'
    },
    {
      label: 'On Track',
      icon: 'ClockFilled',
      value: `0`,
      description: 'Overall task completion rate',
      arrow: 'ArrowLineUpFilled',
      progress: 30
    }
  ]);
  const [channelEngagement] = useState([
    { label: 'Email', count: 10 },
    { label: 'SMS', count: 20 },
    { label: 'WhatsApp', count: 100 }
  ]);

  useEffect(() => {
    const init = async() => {
      try {
        await Promise.all([getWorkflows(), getAccountType()]);
        await loadDashboardData();
      } catch (error) {
        console.error('Initialization error:', error);
      }
    };
    init();
    getCustomerGrowth();
    getLoacations();
  }, []);

  console.log('dashboardCards', countriesList);

  const getLoacations = async() => {
    try {
      const res = await ClientsAPI.getLoacations();
      if (res) {
        setLocationsData(res);
        setSelectedCountry(res[0]);
      }
      return [];
    } catch (error) {
      console.error('Error fetching workflows:', error);
      return [];
    }
  };
  const getCustomerGrowth = async() => {
    try {
      const res = await ClientsAPI.getCustomerGrowth();
      if (res) {
        setCustomerGrowth(res);
      }
      return [];
    } catch (error) {
      console.error('Error fetching workflows:', error);
      return [];
    }
  };

  const getWorkflows = async() => {
    try {
      const res = await ClientsAPI.getCustomerWorkflow();
      if (res) {
        setWorkflows(res);
        if (!res.length) await updateWorkflow();
      }
    } catch (error) {
      console.error('Error fetching workflows:', error);
    }
  };

  const getAccountType = async() => {
    try {
      const res = await ClientsAPI.getCustomerTypes();
      if (res) {
        setAccountType(res);
        if (!res.length) await updateType();
      }
    } catch (error) {
      console.error('Error fetching account types:', error);
    }
  };

  const updateWorkflow = async() => {
    try {
      const res = await ClientsAPI.updateCustomerWorkflow({
        workflow: CUSTOMER_MANAGEMNT_WORKFLOW
      });
      if (res?.status === 200) await getWorkflows();
    } catch (error) {
      console.error('Error updating workflow:', error);
    }
  };

  const updateType = async() => {
    try {
      const res = await ClientsAPI.updateCustomerTypes({ type: ATYPE });
      if (res) await getAccountType();
    } catch (error) {
      console.error('Error updating account type:', error);
    }
  };

  const loadDashboardData = async() => {
    await Promise.all([
      getTotalCount(),
      getOnTrackTotalCount(),
      getActiveCustomersCount(),
      getWorkflowCount(),
      getTypeCount(),
      getRatingsSummary(),
      getEngagenementRating()
    ]);
  };

  const getTotalCount = async() => {
    try {
      const res = await ClientsAPI.getTotalCount();
      let cards = dashboardCards;
      cards[0].value = res.count || 0;
      setDashboardCards(cards);
    } catch (error) {
      console.error('Error fetching total count:', error);
    }
  };

  const getOnTrackTotalCount = async() => {
    try {
      const res = await ClientsAPI.getOnTrackTotalCount();
      let cards = dashboardCards;
      cards[2].value = res.onTrackCount || 0;
      setDashboardCards(cards);
    } catch (error) {
      console.error('Error fetching on track total count:', error);
    }
  };

  

  const getActiveCustomersCount = async() => {
    try {
      const res = await ClientsAPI.getActiveCustomersCount();
      let cards = dashboardCards;
      cards[1].value = res.count || 0;
      setDashboardCards(cards);
    } catch (error) {
      console.error('Error fetching active customers count:', error);
    }
  };

  const getWorkflowCount = async() => {
    try {
      const res = await ClientsAPI.getWorkflowCount();
      if (res) setWorkflowCount(res.statusSummary || []);
    } catch (error) {
      console.error('Error fetching workflow count:', error);
    }
  };

  const getTypeCount = async() => {
    try {
      const res = await ClientsAPI.getTypeCount();
      if (res) {
        const activityColors = [
          '#8DAA5B', '#4C4C87', '#F26430', '#5A9BD4',
          '#C96F6F', '#A678D1', '#E6A157', '#3F7C85',
          '#7E5F9E', '#D75A4A', '#5C8D89', '#BC804E'
        ];
        const ROW_COUNT = 4;
        const COLS = Math.ceil(res.typeSummary.length / ROW_COUNT);
        const activities = res.typeSummary.map((item, index) => {
          const row = Math.floor(index / COLS);
          const col = index % COLS;
          return {
            name: item.label,
            x: 15 + col * 30,
            y: 50 - row * 20,
            color: activityColors[index % activityColors.length],
            rotation: [-10, 0, 10][index % 3],
            value: item.count
          };
        });
        setTypeCount(activities);
      }
    } catch (error) {
      console.error('Error fetching type count:', error);
    }
  };

  const getRatingsSummary = async() => {
    try {
      const res = await ClientsAPI.getRatingsSummary();
      console.log("Ratings Summary Response:", res);
      setRatingsData(res.data);
    } catch (error) {
      console.error("Error fetching ratings summary:", error);
    }
  };
  const getEngagenementRating = async() => {
    try {
      const res = await ClientsAPI.getEngagenementRating();
      console.log("Engagement Rating Response:", res);
      if (res?.data) {
        setEngagementData(res); // 👈 store full response, not res.data
      }
    } catch (error) {
      console.error("Error fetching engagement rating:", error);
    }
  };


  const [loadingCards] = useState(false);
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentRowOne}>
        <div className={styles.contentBoxWrapper}>
          <div className={styles.contentBox}>
            {
              !loadingCards && dashboardCards.length > 0 && dashboardCards.map((i) => <div key={i} className={styles.card}>
                <div className={styles.icon}>
                  <KoIcon name={i.icon} width={46} height={46} />
                </div>
                <div className={styles.mycontent}>
                  <KoText className={styles.label} text={i.label} />
                  <KoTitle level={1} className={styles.value} text={i.value} />
                  {/* <div className={styles.descriptionBox}>
                    <KoIcon name={i.arrow} width={16} height={16} />
                    <KoText className={styles.description} text={i.description} />
                  </div> */}
                </div>
              </div>)
            }
            {
              loadingCards && [1, 2, 3].map((i) => <KoSkeleton active={true} key={i} type={'card'} />)
            }
          </div>
          <div className={styles.graphWrapper}>
            <KoTitle text={`Customer Growth`} level={4} />
            <div className={styles.graph}>
              <KoCharts option={RoundedBarLineChartConfig(customerGrowth?.monthlyFlows || [])} />
            </div>
            <div className={styles.footer}>
              <div className={styles.footerItem}>
                <div className={styles.circleWrapper}>
                  <div className={styles.circleList}>
                    <div className={styles.circle}/>
                    <KoTitle text={`Avg. Added`} level={5} />
                  </div>
                  <KoTitle text={`${customerGrowth?.averageAdded?.toFixed(2)}`} level={1} />
                </div>
              </div>
              <div className={styles.footerItem}>
                <div className={styles.circleWrapper}>
                  <div className={styles.circleList}>
                    <div className={styles.circle}/>
                    <KoTitle text={`Avg. Retained`} level={5} />
                  </div>
                  <KoTitle text={`${customerGrowth?.averageDropped?.toFixed(2)}`} level={1} />
                </div>
              </div>
              <div className={styles.footerItem}>
                <div className={styles.circleWrapper}>
                  <div className={styles.circleList}>
                    <div className={styles.circle}/>
                    <KoTitle text={`Avg. Dropped`} level={5} />
                  </div>
                  <KoTitle text={`${customerGrowth?.averageRetained?.toFixed(2)}`} level={1} />
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className={styles.contentRecentWrapper}>
          <div className={styles.contentRecent}>
            <div className={styles.ticketSalesCard}>
              <KoTitle className={styles.title} text={`Account Types Summary`} level={4} />
              <KoCharts option={LollipopLabelChart(typeCount)} />
            </div>
            <div className={styles.recentActivities}>
              <div className={styles.ticketSalesCard}>
                <KoTitle className={styles.title}  text={`Customer Status`} level={4} />
                <KoCharts option={EventsByTypeChart(workflowCount)} />
              </div>
            </div>
          </div>

        </div>

        <div className={styles.ticketSales}>
          <div className={styles.ticketSalesCard}>
            <KoTitle text={`Channel Engagement`} level={4} />
            <KoCharts option={ChannelByTypeChart(channelEngagement)} />
          </div>
          {/* <div className={styles.ticketSalesCard}>
            <KoTitle text={`Customer Conversion`} level={4} />
            <KoCharts option={TicketStepLineChart(workflowCount)} />
          </div> */}
          <div className={`${styles.ticketSalesCard} ${styles.ticketSalesCardLarge}`}>
            <KoTitle text={`Customer Ratings Summary`} level={4} />
            {/* <KoCharts option={RatingByTypeChart(RatingsData)} /> */}
            <KoCharts option={RatingByTypeChart(RatingsData)} />
          </div>

        </div>
      </div>

      {/* 
      <SummaryCards />

      <Row gutter={16} className={styles.section}>
        <Col span={16}><RevenueChart /></Col>
        <Col span={8}><RecentActivities /></Col>
      </Row>

      <Row gutter={16} className={styles.section}>
        <Col span={8}><EventList /></Col>
        <Col span={8}><EngagementCalendar /></Col>
        <Col span={8}><TicketSales /></Col>
      </Row> */}

      <div className={styles.breakdown}>
        <div className={styles.events}>
          <div className={styles.event}>
            <KoTitle text="Customer location" level={4} />

              
            <div className={styles.eventList}>
              {locationsData?.map((item, i) => (
                <div
                  key={i}
                  className={styles.eventBox}
                  onClick={() => setSelectedCountry(item)}
                >
                  <div className={styles.eventData}>
                    <div className={styles.eventIcon}>
                      <span style={{ fontSize: 25, lineHeight: "25px" }}>
                        {_get(_find(countriesList, { isoCode: item.country }), "flag", "")}
                      </span>
                    </div>

                    <div className={styles.eventName}>
                      <KoText
                        className={styles.eventTitle}
                        ellipsis={true}
                        text={`${item.city}, ${_get(
                          _find(countriesList, { isoCode: item.country }),
                          "name",
                          ""
                        )}`}
                      />
                      <div className={styles.eventTime}>
                        <div className={styles.eventTimeItem}>
                          <KoIcon name="ClientsOutlined" width={14} height={14} />
                          <KoText className={styles.eventDate} text="Total Customers" />
                        </div>
                        <div className={styles.eventTimeItem}>
                          <KoTitle
                            level={5}
                            className={styles.eventDate}
                            text={`${item.value}`}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className={styles.location}>
            <KoIcon name={'MapFilled'} width={350} height={340} />
            <div className={styles.locationText}>
              <div className={styles.locationItem}>
                <KoTitle ellipsis={true} text={`Location`} level={5} />
                <div className={styles.locationBox}>
                  <KoIcon name={'LocationFilled'} width={20} height={20} />
                  <div className={styles.locationContent}>
                    <KoText text={`${selectedCountry?.city}, ${selectedCountry?.country}`} />
                    <KoText text={`Total Customers ${selectedCountry?.value}`} />
                  </div>
                </div>
              </div>
              <KoIcon name={'MapOutlined'} color={'var(--palette-gray-7)'} width={30} height={30} />
            </div>
          </div>
        </div>
        <div className={styles.contentEngagement}>
          <KoTitle text={`Rating Engagement`} level={5} />
          <KoCharts option={RatingChartConfig(engagementData?.data)} />
        </div>
      </div>
    </div>
  );
}

